import { render, staticRenderFns } from "./ClientQuestionsWidget.vue?vue&type=template&id=1fdc58b4&scoped=true"
import script from "./ClientQuestionsWidget.vue?vue&type=script&lang=js"
export * from "./ClientQuestionsWidget.vue?vue&type=script&lang=js"
import style0 from "./ClientQuestionsWidget.vue?vue&type=style&index=0&id=1fdc58b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc58b4",
  null
  
)

export default component.exports